import { useEffect } from "react";
import { Flex, Loading } from "@paguelofacil/pf-components";

import { STEPS_CRYPTO_PAYMENT } from "../services/utils/Constants";

import CoinAndNetworkForm from "./CoinAndNetworkForm";
import DetailsPaymentCrypto from "./DetailsPaymentCrypto";
import useStore from "../services/store/useStore";

const CryptoSdk = () => {
    const { setCurrentStepCrypto, currentStepCrypto } = useStore(state => state);

    useEffect(() => {
        setCurrentStepCrypto({ ...currentStepCrypto, ref: STEPS_CRYPTO_PAYMENT.COIN_NETWORK });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Loading isLoading={STEPS_CRYPTO_PAYMENT.LOADING_DATA === currentStepCrypto.ref}>
            <Flex direction="column" gap="1.5rem" style={{ marginTop: "1rem" }}>
                {currentStepCrypto.ref === STEPS_CRYPTO_PAYMENT.COIN_NETWORK && (
                    <CoinAndNetworkForm
                        isLoading={STEPS_CRYPTO_PAYMENT.LOADING_DATA === currentStepCrypto.ref}
                        setCurrentStep={setCurrentStepCrypto}
                    />
                )}
                {currentStepCrypto.ref === STEPS_CRYPTO_PAYMENT.DETAILS_PAYMENT && (
                    <DetailsPaymentCrypto
                        isLoading={STEPS_CRYPTO_PAYMENT.LOADING_DATA === currentStepCrypto.ref}
                        setCurrentStep={setCurrentStepCrypto}
                        currentStep={currentStepCrypto}
                    />
                )}
            </Flex>
        </Loading>
    );
};

export default CryptoSdk;
